import { render, staticRenderFns } from "./desc-penilaian.vue?vue&type=template&id=60eb11f2&scoped=true&"
import script from "./desc-penilaian.vue?vue&type=script&lang=js&"
export * from "./desc-penilaian.vue?vue&type=script&lang=js&"
import style0 from "./desc-penilaian.vue?vue&type=style&index=0&id=60eb11f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eb11f2",
  null
  
)

export default component.exports